import { Component } from '@angular/core';

@Component({
    selector: 'pp-notification-comment-mention',
    templateUrl: './notification-comment-mention.component.html',
    styleUrls: ['../notification.component.scss'],
    standalone: false
})
export class NotificationCommentMentionComponent {
  constructor() {}
}
